var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionPage',{attrs:{"img":_vm.img,"content":_vm.content,"btn":_vm.btn,"icon":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }